export default "__VITE_ASSET__61281ce2__"